import { safeSessionStorage } from './ssr-helper';
import { SESSION_STORAGE_KEYS } from '../constants';

const KEY = SESSION_STORAGE_KEYS.FLIGHT_SEARCH_STATE;

const EMPTY_STATE = {
  flightInfo: null,
  flightSelections: {},
  selectedFare: null,
  isOnlyOneWay: false,
  expCacheDate: null,
  lastEssentialSearchParams: '',
  previousSearchUrl: '',
};

export function getFlightSearchState() {
  try {
    const stored = safeSessionStorage.getItem(KEY);
    if (!stored) return { ...EMPTY_STATE };
    const parsed = JSON.parse(stored);
    return { ...EMPTY_STATE, ...parsed };
  } catch (error) {
    console.warn('[flightSearchStateStorage] Error reading:', error);
    return { ...EMPTY_STATE };
  }
}

export function updateFlightSearchState(partial) {
  try {
    const current = getFlightSearchState();
    const next = { ...current, ...partial };
    safeSessionStorage.setItem(KEY, JSON.stringify(next));
    return next;
  } catch (error) {
    console.warn('[flightSearchStateStorage] Error updating:', error);
    return getFlightSearchState();
  }
}

export function clearFlightSearchState() {
  try {
    safeSessionStorage.removeItem(KEY);
  } catch (error) {
    console.warn('[flightSearchStateStorage] Error clearing:', error);
  }
}
